import { memo, forwardRef } from "react";
import Calendar from "@toast-ui/react-calendar";
import "@toast-ui/calendar/dist/toastui-calendar.min.css";
import { CalendarView } from "src/utils/constants";
import { IMeeting } from "..";
import { getTimeInAMPMFormat } from "src/utils/dateHelper";

type IProps = {
  height: string;
  view: CalendarView;
  meetings: IMeeting;
  handleModal: (id?: string | null, start?: Date) => void;
  isAllowWrite: boolean;
};

const template = {
  // Event Label Changes (Date: AM | PM format)
  time(event: any) {
    return `<span>
    <span style="font-weight:700">${getTimeInAMPMFormat(event.start)}</span>
    - ${event.title}</span>`;
  },
};

const CalendarComponent = forwardRef<any, IProps>(
  ({ view, meetings, handleModal, height, isAllowWrite }, ref) => {
    return (
      <Calendar
        height={height}
        view={view}
        ref={ref}
        events={meetings.map((e) => ({
          id: e.id,
          title: e.name,
          start: e.startAt,
          end: e.endAt,
        }))}
        onClickEvent={({ event }) => handleModal(event.id)}
        week={{
          eventView: ["time"],
        }}
        useDetailPopup={false}
        onSelectDateTime={({ start }) =>
          isAllowWrite ? handleModal(null, start) : undefined
        }
        template={template}
      />
    );
  }
);

export default memo(CalendarComponent);
